import React from 'react'

export default function SubmitButton() {
    return (
        <button className="btn btn-primary">
            Send
        </button>
    )
}
